import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ClaService } from './cla.service';

@Injectable()
export class ClaEmployeeGuard implements CanActivate {

    constructor(
        private claService: ClaService
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const employeeId = route.paramMap.get('employeeId');
        return of(this.claService.checkIfEmployeeExists(Number(employeeId)));
    }
}
